
import {
  Activity,
  Shield,
  Server,
  CreditCard,
} from 'lucide-react'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import { Table, TableBody, TableCell, TableRow } from '@/components/ui/table'
import { Skeleton } from '@/components/ui/skeleton'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function ActivityLog({ activities, loading }: { activities: any[], loading: boolean }) {
  if (loading) return <Skeleton className="h-[300px] w-full" />

  const getIcon = (type: string) => {
    switch (type) {
      case 'license': return Shield
      case 'tenant': return Server
      case 'invoice': return CreditCard
      default: return Activity
    }
  }

  return (
    <Card className="border-slate-200 dark:border-slate-800 h-full flex flex-col">
      <CardHeader className="border-b pb-3 bg-muted/20">
        <div className="flex items-center justify-between">
          <CardTitle className="text-sm font-mono uppercase tracking-wider text-muted-foreground">System Log</CardTitle>
          <div className="flex items-center gap-2">
            <span className="flex h-2 w-2 rounded-full bg-emerald-500 animate-pulse" />
            <span className="text-xs text-muted-foreground font-mono">LIVE</span>
          </div>
        </div>
      </CardHeader>
      <CardContent className="p-0 flex-1 overflow-auto">
        <Table>
          <TableBody>
            {activities.length === 0 ? (
               <TableRow>
                 <TableCell colSpan={4} className="h-24 text-center text-muted-foreground text-xs font-mono">
                   -- NO ACTIVITY RECORDED --
                 </TableCell>
               </TableRow>
            ) : (
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              activities.map((log: any) => {
                const Icon = getIcon(log.type)
                return (
                  <TableRow key={log.id} className="border-b-slate-100 dark:border-b-slate-800/50 hover:bg-muted/30">
                    <TableCell className="py-3 pl-4 w-[40px]">
                      <Icon className="h-4 w-4 text-muted-foreground" />
                    </TableCell>
                    <TableCell className="py-3 font-medium text-sm">
                      {log.action}
                    </TableCell>
                    <TableCell className="py-3 text-xs font-mono text-muted-foreground">
                      {log.subject}
                    </TableCell>
                    <TableCell className="py-3 pr-4 text-right text-xs text-muted-foreground font-mono">
                      {new Date(log.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                    </TableCell>
                  </TableRow>
                )
              })
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  )
}

export { ActivityLog as DashboardActivityLog }
